// Modo desarrollo
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Modo produccion
import { ViteReactSSG } from 'vite-react-ssg'
import { staticRoutes } from './ViteSSGRoutes.tsx'

const isDevelopment = import.meta.env.MODE === "development";

if (isDevelopment) {
    // Modo desarrollo
    const root = ReactDOM.createRoot(document.getElementById('root')!);
    root.render(
        <StrictMode>
            <App />
        </StrictMode>,
    )
}

export const createRoot = !isDevelopment 
                          ? ViteReactSSG({ routes: staticRoutes, future: { v7_startTransition: true, v7_relativeSplatPath: true} }) 
                          : undefined;
